<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">New ledger</div>

          <div class="card-body">
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <div v-if="message" class="alert alert-success">{{ message }}</div>

            <div class="form-group row">
              <label for="name" class="col-md-4 col-form-label text-md-right">Name</label>

              <div class="col-md-6">
                <input id="name" v-model="form.name" :class="{ 'is-invalid': errors.name }" type="text" class="form-control" autocomplete="off" required>
                <span v-if="errors.name" class="invalid-feedback">
                  <div v-for="(error, index) in errors.name" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="name" class="col-md-4 col-form-label text-md-right">Currency</label>

              <div class="col-md-6">
                <input id="currency" v-model="form.currency" :class="{ 'is-invalid': errors.currency }" type="text" class="form-control" required>
                <span v-if="errors.currency" class="invalid-feedback">
                  <div v-for="(error, index) in errors.currency" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row mb-0">
              <div class="col-md-6 offset-md-4">
                <button type="submit" class="btn btn-primary" @click.prevent="submit()">
                  <span v-if="this.$loading.isLoading('ledger-creating')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Create
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'CreateLedger',
  data () {
    return {
      form: {
        name: '',
        currency: ''
      },
      error: '',
      errors: {},
      message: ''
    }
  },
  methods: {
    ...mapActions([
      'createLedger'
    ]),
    submit () {
      this.$loading.startLoading('ledger-creating')
      this.errors = {}
      this.createLedger(this.form)
        .then((data) => {
          this.$loading.endLoading('ledger-creating')
          this.error = ''
          this.errors = {}
          this.message = data.message
          this.$router.push({ name: 'Ledger', params: { id: data.ledger.id } })
        })
        .catch((data) => {
          this.error = data.message
          this.errors = data.errors || {}
          this.$loading.endLoading('ledger-creating')
        })
    }
  }
}
</script>
